import { render, staticRenderFns } from "./AccountDataV3.vue?vue&type=template&id=878a8efa&"
import script from "./AccountDataV3.vue?vue&type=script&lang=js&"
export * from "./AccountDataV3.vue?vue&type=script&lang=js&"
import style0 from "./AccountDataV3.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports